export default __webpack_public_path__ + "static/media/close.c88be099.svg";